module.exports = __webpack_public_path__ + "img/alpine.aa90ad2c.png";